import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { UserProvider } from './context/user';
import { App } from './App';
import '@primer/primitives/dist/css/functional/themes/light.css'
import { BaseStyles, ThemeProvider } from '@primer/react'

if (process.env.NODE_ENV === 'development') {
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React, {
    trackAllPureComponents: true,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
    },
  },
});

root.render(
  <React.StrictMode>
    <QueryClientProvider client={client}>
      <UserProvider>
        <ThemeProvider>
          <BaseStyles>
            <App />
          </BaseStyles>
        </ThemeProvider>
      </UserProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);


reportWebVitals();
